import api from '../api';

export const getListTemplate = async () => {
    const result = await api.get('/admin/template');
    return result.data;
}

export const getOneTemplate = async (id) => {
    const result = await api.get(`/admin/template/${id}`);
    return result.data.template[0];
}

export const createTemplate = async (data) => {
    try {
        const response = await api.post('/admin/template', data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateTemplate = async (data, id) => {
    return await api.post(`/admin/template/${id}`, data);
}

export const deleteTemplate = async (id) => {
    try {
        const response = await api.delete(`/admin/template/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}



